import { render } from "./eb-modal.vue?vue&type=template&id=5e21b408"
import script from "./eb-modal.vue?vue&type=script&lang=ts"
export * from "./eb-modal.vue?vue&type=script&lang=ts"
script.render = render

export default script